<template>
    <v-dialog v-model="shows" width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="primary">취소 사유 설정</v-btn>
        </template>
        <v-card>
            <v-row no-gutters>
                <v-col cols="5">
                    <v-card-title>취소 사유 설정</v-card-title>
                </v-col>
                <v-col class="d-flex align-center justify-end mr-4">
                    <cancel-reasons-create-dialog @update="update">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon text v-bind="attrs" v-on="on" color="primary">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                    </cancel-reasons-create-dialog>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-data-table :items="form" :headers="itemHeaders" disable-sort>
                        <template #[`item.actions`]="{ item, index }">
                            <cancel-reasons-create-dialog v-bind="{ value: item, index }" @update="update">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                                </template>
                            </cancel-reasons-create-dialog>
                            <v-icon small class="ml-1" @click="remove(index)">mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import CancelReasonsCreateDialog from "./cancel-reasons-create-dialog.vue";

export default {
    components: {
        CancelReasonsCreateDialog,
    },
    data: () => ({
        shows: false,
        form: [],
        itemHeaders: [
            { text: "내용", value: "subject" },
            { text: "actions", value: "actions", width: 10 },
        ],
    }),
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            try {
                let { setting } = await api.console.common.setting.get({});
                this.form = [...setting?.cancelReasons];
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async save() {
            try {
                await api.console.common.setting.put({ cancelReasons: this.form });
                alert("저장되었습니다");
                this.shows = false;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        update(value) {
            let { index, subject } = value;
            if (index !== 0 && !index) {
                this.form.push(value);
            } else {
                this.form[index].subject = subject;
            }
        },
        remove(index) {
            this.form.splice(index, 1);
        },
    },
    watch: {
        shows() {
            if (this.shows) this.search();
        },
    },
};
</script>

<style>
</style>